import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../crbt/crbtuicss';

export interface WishlistCSSStyle extends CRBTUICSSStyle
{

}

export class  WishlistCSSStyleImpl extends CRBTUICSSStyleImpl implements WishlistCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            width:"100%",
            height:'auto',//changed
            display:'flex',
            justifyContents: "center",
            flexDirection: "row",
            flexFlow: "row wrap"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/wishlist/wishlistcss.tsx